import { render, staticRenderFns } from "./MkChart.vue?vue&type=template&id=1165b699&scoped=true"
import script from "./MkChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MkChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MkChart.vue?vue&type=style&index=0&id=1165b699&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165b699",
  null
  
)

export default component.exports